/**
 * CohortReadiness — at-a-glance view of how close each EKSELENS360 sub-brand is
 * to unlocking peer-benchmark context in its board packs (needs N completed runs).
 */
import React, { useEffect, useState } from "react";
import { Users } from "lucide-react";
import api from "../../lib/api";

export default function CohortReadiness() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/admin/assessments/cohort-readiness").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data || !data.frameworks?.length) return null;
  const min = data.min_required;

  return (
    <div className="border border-zinc-200 bg-white p-4 mb-6" data-testid="cohort-readiness">
      <div className="flex items-center gap-2 mb-3">
        <Users size={15} className="text-[#7737F6]" />
        <span className="text-[11.5px] font-medium tracking-[0.14em] uppercase text-zinc-600">Peer-benchmark readiness</span>
        <span className="text-[11px] text-zinc-400">unlocks at {min} completed runs per sub-brand</span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2">
        {data.frameworks.map((f) => {
          const pct = Math.min(100, Math.round((f.completed / min) * 100));
          return (
            <div key={f.framework_id} className="border border-zinc-100 px-3 py-2" data-testid={`cohort-${f.sub_brand}`}>
              <div className="flex items-center justify-between">
                <span className="text-[12.5px] font-medium text-black">{f.sub_brand}</span>
                <span className={`text-[10.5px] font-semibold ${f.ready ? "text-emerald-600" : "text-zinc-400"}`}>
                  {f.completed}/{min}
                </span>
              </div>
              <div className="h-1 bg-zinc-100 mt-1.5">
                <div className={`h-1 ${f.ready ? "bg-emerald-500" : "bg-[#7737F6]"}`} style={{ width: `${pct}%` }} />
              </div>
              <div className="text-[10px] mt-1 text-zinc-500">
                {f.established ? "Established cohort" : f.ready ? "Peer context live" : `${min - f.completed} more to unlock`}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
